import React, { useEffect, useState } from "react";
import { useUpload } from "../../context/UploadContext";

const GlobalUploadLoader = () => {
  const { uploadState } = useUpload();
  const [timeLeft, setTimeLeft] = useState(uploadState?.estimatedTime);

  useEffect(() => {
    if (uploadState?.isUploading && uploadState?.estimatedTime) {
      setTimeLeft(uploadState?.estimatedTime);
      const interval = setInterval(() => {
        setTimeLeft((prev) => (prev > 1 ? prev - 1 : 0));
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [uploadState?.isUploading, uploadState?.estimatedTime]);

  if (!uploadState?.isUploading) return null;

  // Calculate progress based on time
  const total = uploadState?.estimatedTime || 1;
  const elapsed = total - timeLeft;
  const progress = Math.min(100, Math.round((elapsed / total) * 100));

  return (
    <div className="global-upload-loader">
      <div className="loader-content">
        <div className="spinner" />
        <div>
          <strong>Trwa przesyłanie plików...</strong>
          <div className="mt-1">
            Szacowany czas:{" "}
            {timeLeft > 0 ? `${Math.ceil(timeLeft)}s` : "Kończenie..."}
          </div>
          <div className="progress-bar">
            <div className="progress" style={{ width: `${progress}%` }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalUploadLoader;
